import { type Enum } from '@webapp/infrastructure/types/Enum'

export const VendorInviteStatuses = {
  SENT: 'sent',
  VIEWED: 'viewed',
  ACCEPTED: 'accepted',
  CONNECTED: 'connected',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
  DISCONNECTED: 'disconnected',
} as const

export type VendorInviteStatusEnum = Enum<typeof VendorInviteStatuses>
